export const is5xxHttpStatus = (status: number): boolean => status >= 500 && status < 600;
